import env from "./env.development.js";

export default {
    ...env,
    ONESIGNAL_APP_ID: '0beb2484-cacb-4c17-aeaf-6507b67b6ffd',
    IS_DEVELOPMENT : false,
}
